import React from 'react';

export type TStringTranslationsFunction = (key: string | string[], options?: any) => string;

export interface ITranslationsContext {
	selectedLangCode: string;
	setSelectedLangCode: React.Dispatch<React.SetStateAction<string>>;
	t: TStringTranslationsFunction;
}

const TranslationsContext = React.createContext<ITranslationsContext | null>(null);

export default TranslationsContext;
